require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-artificial-intelligence-meets-the-real-world.json") })
        }
      }, "path---news-artificial-intelligence-meets-the-real-world");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-artificial-intelligence-meets-the-real-world!./.cache/json/news-artificial-intelligence-meets-the-real-world.json
// module id = 1416
// module chunks = 231608221292675